<template>
  <div>
    <header class="main_header_arae">
      <div class="navbar-area is-sticky">
        <div class="main-responsive-nav">
          <div class="container">
            <div class="main-responsive-menu mean-container">
              <nav class="navbar">
                <div class="container">
                  <div class="logo">
                    <router-link to="/">
                      <img :src="require('../assets/img/logo.png')" alt="logo" />
                    </router-link>
                  </div>

                  <!-- We control the toggle ourselves (no data-bs-*) -->
                  <button class="navbar-toggler" type="button" :aria-expanded="String(isMenuOpen)"
                    aria-controls="navbar-content" aria-label="Toggle navigation" @click="toggleMenu">
                    <div class="hamburger"><span></span><span></span><span></span></div>
                  </button>

                  <div class="collapse navbar-collapse mean-nav" id="navbar-content">
                    <ul class="navbar-nav mr-auto mb-lg-0">
                      <li class="nav-item">
                        <router-link to="/about-us" class="dropdown-item">{{ $t("about_us") }}</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/contact" class="dropdown-item">{{ $t("contact_us") }}</router-link>
                      </li>

                      <div class="d-flex align-content-center" v-if="!isAuthenticated">
                        <ul class="">
                          <li class="nav-item">
                            <router-link to="/login" class="nav-link text-center">{{ $t("login") }}</router-link>
                          </li>
                          <li class="nav-item">
                            <router-link to="/register#trips" class="nav-link text-center">{{ $t("sign_up")
                              }}</router-link>
                          </li>
                          <li class="nav-item" :title="$t('management_panel')">
                            <a href="https://app.selah.agency/" class="nav-link text-center" target="_blank"
                              rel="noopener noreferrer">
                              {{ $t("extranet") }}
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div class="d-flex align-content-center" v-else>
                        <ul class="">
                          <li class="nav-item" style="background-color: #ffe0dc;">
                            <router-link
                              :title="fullName"
                              to="#"
                              class="nav-link text-center"
                            >
                              {{ fullName }}
                            </router-link>
                          </li>
                          <li class="nav-item">
                            <router-link to="/" class="nav-link text-center" @click.prevent="handleLogout">
                              {{ $t("logout") }}
                            </router-link>
                          </li>
                          <li class="nav-item" :title="$t('management_panel')">
                            <a href="https://app.selah.agency/" class="nav-link text-center" target="_blank"
                              rel="noopener noreferrer">
                              {{ $t("extranet") }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </ul>

                    <ul class="d-flex align-content-center navbar-nav-last">
                      <li class="">
                        <a target="_blank" class="text-center" href="https://www.facebook.com/Selahcomfort">
                          <i class="fab d-block text-coral fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a target="_blank" class="text-center" href="https://www.youtube.com/@selahcomfort">
                          <i class="fa-brands d-block text-coral fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a target="_blank" class="text-center" href="https://www.tiktok.com/@selahcomfort">
                          <i class="fa-brands d-block text-coral fa-tiktok"></i>
                        </a>
                      </li>
                      <li>
                        <a target="_blank" class="text-center" href="https://instagram.com/selahcomfort_">
                          <i class="fab d-block text-coral fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <div class="dropdown">
                          <button class="dropdown-button">
                            <img class="selected-flag" :src="flagUrl" :alt="language" />
                          </button>
                          <div class="dropdown-content">
                            <a class="router-link-active router-link-exact-active" @click="changeLanguage('es')"
                              :data-image="require('../assets/img/flags/es.svg')" data-text="ES"
                              :class="{ 'dropdown-content-hover': language == 'es' }">
                              <img src="../assets/img/flags/es.svg" alt="es" />
                              {{ $t("spanish") }}
                            </a>
                            <a class="router-link-active router-link-exact-active" @click="changeLanguage('us')"
                              data-text="US" :data-image="require('../assets/img/flags/us.svg')"
                              :class="{ 'dropdown-content-hover': language == 'us' }">
                              <img src="../assets/img/flags/us.svg" alt="US" />
                              {{ $t("english") }}
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>

        <div class="main-navbar">
          <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
              <router-link class="navbar-brand" to="/">
                <img :src="require('@/assets/img/logo.png')" alt="logo" class="logo" />
              </router-link>

              <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                <ul class="navbar-nav align-items-center justify-content-center">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link">{{ $t("home") }}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/about-us" class="nav-link">{{ $t("about_us") }}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/contact" class="nav-link">{{ $t("contact_us") }}</router-link>
                  </li>
                </ul>

                <div
                  class="outline-btn rounded-pill py-2 mx-1 d-flex align-items-center justify-content-center"
                  v-if="!isAuthenticated">
                  <ul class="navbar-nav btn-btn mx-3 align-items-center justify-content-center">
                    <li class="nav-item">
                      <router-link to="/login" class="nav-link">{{ $t("login") }}</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link to="/register#trips" class="nav-link">{{ $t("sign_up") }}</router-link>
                    </li>
                    <li class="nav-item" :title="$t('management_panel')">
                      <a href="https://app.selah.agency/" class="nav-link" target="_blank" rel="noopener noreferrer">
                        {{ $t("extranet") }}
                      </a>
                    </li>
                  </ul>
                </div>

                <div
                  class="outline-btn rounded-pill py-2 mx-1 d-flex align-items-center justify-content-center"
                  v-else>
                  <ul class="navbar-nav btn-btn mx-3 align-items-center justify-content-center">
                    <li class="nav-item">
                      <router-link to="#" :title="fullName" class="nav-link user-avatar">{{ userInitial }}</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link to="/" class="nav-link" @click.prevent="handleLogout">{{ $t("logout")
                        }}</router-link>
                    </li>
                    <li class="nav-item" :title="$t('management_panel')">
                      <a href="https://app.selah.agency/" class="nav-link" target="_blank" rel="noopener noreferrer">
                        {{ $t("extranet") }}
                      </a>
                    </li>
                  </ul>
                </div>

                <ul class="topbar-list btn-btn">
                  <li class="social-wrapper">
                    <div class="social-grid">
                      <a target="_blank" href="https://www.facebook.com/Selahcomfort">
                        <i class="fab fa-facebook-f"></i>
                      </a>
                      <a target="_blank" href="https://www.youtube.com/@selahcomfort">
                        <i class="fa-brands fa-youtube"></i>
                      </a>
                      <a target="_blank" href="https://www.tiktok.com/@selahcomfort">
                        <i class="fa-brands fa-tiktok"></i>
                      </a>
                      <a target="_blank" href="https://instagram.com/selahcomfort_">
                        <i class="fab fa-instagram"></i>
                      </a>
                    </div>
                  </li>
                  <li class="language-wrapper">
                    <div class="dropdown">
                      <button class="dropdown-button">
                        <img class="selected-flag" :src="flagUrl" :alt="language" />
                      </button>
                      <div class="dropdown-content">
                        <a class="router-link-active router-link-exact-active nav-link" @click="changeLanguage('es')"
                          :data-image="require('../assets/img/flags/es.svg')" data-text="ES"
                          :class="{ 'dropdown-content-hover': language == 'es' }">
                          <img src="../assets/img/flags/es.svg" alt="es" />
                          {{ $t("spanish") }}
                        </a>
                        <a class="router-link-active router-link-exact-active nav-link" @click="changeLanguage('us')"
                          data-text="US" :data-image="require('../assets/img/flags/us.svg')"
                          :class="{ 'dropdown-content-hover': language == 'us' }">
                          <img src="../assets/img/flags/us.svg" alt="US" />
                          {{ $t("english") }}
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Collapse from "bootstrap/js/dist/collapse";

export default {
  name: "Header",
  data() {
    return {
      language: "es",
      currency: "COP",
      isSticky: false,
      isMenuOpen: false, // reactive state we keep in sync

      // internal refs/listeners
      bs: null,
      onDocClick: null,
      onGlobalDropdownClick: null,
      onShown: null,
      onHidden: null,
      overlayEl: null,
      removeAfterEachHook: null,
    };
  },

  computed: {
    ...mapState("autentication", ["isAuth", "name"]),
    isAuthenticated() {
      return this.isAuth;
    },
    flagUrl() {
      return require(`../assets/img/flags/${this.language}.svg`);
    },
    fullName() {
      return localStorage.getItem("name");
    },
    userInitial() {
      const name = this.fullName;
      if (!name) return "";
      const trimmed = name.trim();
      if (!trimmed) return "";
      return trimmed.charAt(0).toUpperCase();
    },
  },

  mounted() {
    // --- Language boot ---
    let lang = localStorage.getItem("lang");
    if (lang == null) {
      localStorage.setItem("lang", "es");
      lang = "es";
    }
    this.language = lang;
    if (this.$i18n) this.$i18n.locale = this.language;

    // --- Dropdowns (independent) ---
    const dropdowns = document.querySelectorAll(".dropdown");
    const closeAll = (except = null) => {
      document.querySelectorAll(".dropdown-content.is-open").forEach((dc) => {
        if (dc !== except) {
          dc.classList.remove("is-open");
          const btn = dc.closest(".dropdown")?.querySelector(".dropdown-button");
          if (btn) btn.setAttribute("aria-expanded", "false");
        }
      });
    };

    dropdowns.forEach((dropdown) => {
      const btn = dropdown.querySelector(".dropdown-button");
      const content = dropdown.querySelector(".dropdown-content");
      if (!btn || !content) return;

      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const willOpen = !content.classList.contains("is-open");
        closeAll(content);
        content.classList.toggle("is-open", willOpen);
        btn.setAttribute("aria-expanded", String(willOpen));
      });

      btn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
          e.preventDefault();
          btn.click();
        }
      });
    });

    this.onGlobalDropdownClick = (e) => {
      if (!e.target.closest(".dropdown")) closeAll();
    };
    document.addEventListener("click", this.onGlobalDropdownClick);

    // --- Collapse instance (no data-API) ---
    const { menu } = this.getEls();
    if (menu) {
      this.bs = Collapse.getOrCreateInstance(menu, { toggle: false });

      this.onShown = () => {
        this.isMenuOpen = true;
        this.showOverlay();
      };
      this.onHidden = () => {
        this.isMenuOpen = false;
        this.hideOverlay();
      };

      menu.addEventListener("shown.bs.collapse", this.onShown);
      menu.addEventListener("hidden.bs.collapse", this.onHidden);

      // Close menu on any internal link click
      menu.querySelectorAll("a, .nav-link, .dropdown-item").forEach((link) => {
        link.addEventListener("click", this.closeMenu);
      });
    }

    // Close on route change
    if (this.$router?.afterEach) {
      this.removeAfterEachHook = this.$router.afterEach(() => this.closeMenu());
    }

    // --- Outside click for the mobile menu (capture: true) ---
    this.onDocClick = (e) => {
      const { menu } = this.getEls();
      if (!menu) return;
      if (!menu.classList.contains("show")) return;

      const clickedInsideMenu = menu.contains(e.target);
      const clickedToggler = e.target.closest(".navbar-toggler");
      if (!clickedInsideMenu && !clickedToggler) {
        this.bs.hide();
      }
    };
    document.addEventListener("click", this.onDocClick, true); // <-- this was missing
  },

  beforeUnmount() {
    if (this.onDocClick) document.removeEventListener("click", this.onDocClick, true);
    if (this.onGlobalDropdownClick) document.removeEventListener("click", this.onGlobalDropdownClick);

    const { menu } = this.getEls();
    if (menu) {
      if (this.onShown) menu.removeEventListener("shown.bs.collapse", this.onShown);
      if (this.onHidden) menu.removeEventListener("hidden.bs.collapse", this.onHidden);
      menu
        .querySelectorAll("a, .nav-link, .dropdown-item")
        .forEach((link) => link.removeEventListener("click", this.closeMenu));
    }

    if (this.removeAfterEachHook) this.removeAfterEachHook();
    this.hideOverlay();
  },

  methods: {
    ...mapActions("autentication", ["logout"]),

    async handleLogout() {
      try {
        await this.logout();
        this.$router.push("/login");
        this.$forceUpdate();
      } catch (error) {
        if (error?.response?.data?.message) {
          this.showAlert(error.response.data.message, "error");
        } else {
          this.showAlert("Unknown error");
        }
      }
    },

    changeLanguage(lang) {
      this.language = lang;
      if (this.$i18n) {
        this.$i18n.locale = lang;
        localStorage.setItem("lang", lang);
      }
    },

    getEls() {
      const menu = document.getElementById("navbar-content");
      return { menu };
    },

    // Single source of truth: programmatic toggle (no data-API)
    toggleMenu() {
      if (!this.bs) return;
      this.bs.toggle();
    },

    // Force-close; collapse events will sync isMenuOpen and overlay
    closeMenu() {
      if (!this.bs) return;
      this.bs.hide();
    },

    // Overlay helpers
    showOverlay() {
      if (this.overlayEl) return;
      this.overlayEl = document.createElement("div");
      this.overlayEl.className = "nav-overlay";
      this.overlayEl.addEventListener("click", () => this.bs?.hide());
      document.body.appendChild(this.overlayEl);
    },
    hideOverlay() {
      if (!this.overlayEl) return;
      this.overlayEl.remove();
      this.overlayEl = null;
    },
  },
};
</script>

<style scoped>
/* --- Layers / stacking context --- */
.mean-container .navbar {
  position: relative;
}

.mean-container .navbar .navbar-toggler {
  position: relative;
  z-index: 1061;
  /* above menu and overlay */
}

/* Menu panel must be positioned so z-index works */
#navbar-content.mean-nav {
  position: relative;
  z-index: 1050;
  /* above overlay, below toggler */
  top: 0;
}

/* Overlay to catch outside clicks (below menu, above page content) */
.nav-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .25);
  z-index: 1045;
  /* < menu (1050) < toggler (1061) */
}

/* --- Your existing styles --- */
.main-navbar {
  padding: 15px 0;
}

.main_header_arae {
  margin-top: 0px;
  height: 100px;
}

.logo {
  height: auto;
  width: auto;
}

.logo img {
  max-width: 50%;
  height: auto;
}

.mean-menu {
  justify-content: flex-start;
}

ul.btn-btn {
  padding-left: 0px !important;
}

.outline-btn {
  border: 2px solid var(--black-color);
  background-color: transparent;
  color: var(--black-color);
  transition: color .3s, background-color .3s;
}

.outline-btn .navbar-nav {
  display: flex;
  align-items: center;
}

.outline-btn:hover {
  border: 2px solid var(--coral-red-color);
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  padding: 10px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  display: flex;
  align-items: center;
  background-color: transparent !important;
}

.dropdown-button img,
.selected-flag {
  width: 52px;
  border-radius: 12%;
  object-fit: cover;
  display: block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, .2);
  z-index: 1;
  border-radius: 5px;
  right: 0;
}

.dropdown-content.is-open {
  display: block;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.dropdown-content a img {
  width: 36px;
  height: 24px;
  margin-right: 10px;
  border-radius: 10%;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.dropdown-content-hover {
  background-color: #ddd;
}

.navbar {
  height: auto;
}

.navbar-collapse a {
  color: black !important;
}

.navbar-collapse a:hover {
  color: var(--coral-red-color) !important;
}

.navbar-collapse .dropdown-item:hover {
  background-color: #ff6056 !important;
  color: #fff !important;
}

.topbar-list {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.topbar-list .social-wrapper {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
}

.social-grid {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 18px;
}

.social-grid a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: var(--coral-red-color);
  text-decoration: none;
}

.social-grid a i {
  font-size: 1.25rem;
}

.user-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ffe0dc;
  color: #ff6056 !important;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0 !important;
  margin-right: 12px;
}

.user-avatar:hover {
  color: #ff6056 !important;
  background: #ffd1ca;
}

.topbar-list .language-wrapper {
  display: flex;
  justify-content: flex-end;
  min-width: 50px;
}

@media (max-width: 1200px) {
  .topbar-list {
    gap: 16px;
  }

  .outline-btn {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 20px;
    padding-right: 20px;
  }

  .outline-btn .navbar-nav {
    flex-wrap: nowrap;
    gap: 12px;
    justify-content: center;
  }
}

@media (max-width: 992px) {
  .main-navbar .navbar-brand {
    margin-bottom: 16px;
  }

  .mean-menu {
    justify-content: center;
  }

  .main-navbar .navbar-nav {
    gap: 8px;
  }

  .topbar-list {
    justify-content: center;
  }

  .topbar-list .social-wrapper {
    flex: 0 0 auto;
  }

  .topbar-list .language-wrapper {
    justify-content: center;
  }

  .outline-btn .navbar-nav {
    flex-wrap: wrap;
    gap: 8px 16px;
    justify-content: center;
  }

  .social-grid {
    flex-wrap: wrap;
    gap: 10px 18px;
  }
}

@media (max-width: 768px) {
  .topbar-list {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .topbar-list .social-wrapper,
  .topbar-list .language-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .social-grid {
    flex-wrap: wrap;
    gap: 10px 14px;
  }

  .dropdown-button {
    padding: 6px 8px;
  }

  .outline-btn {
    width: 100%;
    justify-content: center;
  }

  .user-avatar {
    margin-right: 0;
  }
}

@media (max-width: 576px) {
  .main_header_arae {
    height: auto;
  }

  .navbar-brand img.logo {
    max-width: 160px;
    height: auto;
  }

  .outline-btn .navbar-nav {
    width: 100%;
  }

  .outline-btn .nav-item {
    flex: 1 1 calc(50% - 12px);
    text-align: center;
  }
}

/* --- Hamburger button --- */
.navbar-toggler {
  position: relative;
  z-index: 1051;
  border: 0;
  padding: .25rem .5rem;
  line-height: 1;
  color: #ff6056;
}

.navbar.navbar-dark .navbar-toggler {
  color: #fff;
}

.hamburger {
  position: relative;
  width: 24px;
  height: 18px;
  display: inline-block;
}

.hamburger span {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: currentColor;
  border-radius: 2px;
  transition: transform .2s ease, opacity .2s ease;
}

.hamburger span:nth-child(1) {
  top: 0;
}

.hamburger span:nth-child(2) {
  top: 8px;
}

.hamburger span:nth-child(3) {
  bottom: 0;
}

/* Open state -> "X" (driven by aria-expanded binding) */
.navbar-toggler[aria-expanded="true"] .hamburger span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.navbar-toggler[aria-expanded="true"] .hamburger span:nth-child(2) {
  opacity: 0;
}

.navbar-toggler[aria-expanded="true"] .hamburger span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}
</style>
